import "../styles/AboutPage.css";
import Dickson from "../images/dickson.jpg"

export default function AboutPage() {
  const timeline = [
    ["2024", "East African Art Prize — Finalist"],
    ["2023", "Solo Exhibition — Zanzibar Cultural Centre"],
    ["2022", "Group Show — Nairobi Contemporary Art Fair"],
    ["2021", "Residency — Alliance Française Dar es Salaam"],
    ["2019", "Best Emerging Artist — Tanzania Arts Council"],
    ["2018", "Dickson Art Gallery Founded"],
  ];

  return (
    <div className="page">
      <div className="section">

        {/* ─── ARTIST BIO ─── */}
        <div className="about-grid">
          <div className="about-portrait">
            <img src={Dickson} alt="Dickson Mwangi" className="about-portrait-img" />
          </div>

          <div className="about-text">
            <span className="about-text-label">The Artist</span>
            <h2>
              Dickson
              <br />
              <em>Mwangi</em>
            </h2>
            <div className="about-rule" />
            <p>
              Dickson Mwangi is a visionary Tanzanian artist whose work bridges
              traditional African aesthetics with contemporary expression. Born in
              Dar es Salaam and rooted in Zanzibar, his practice explores identity,
              memory, and the beauty found in everyday African life.
            </p>
            <p>
              With over a decade of exhibiting work across East Africa and
              internationally, Dickson has earned recognition as one of the region's
              most compelling visual voices. His gallery serves not only as a showcase
              but as a living community hub for art education.
            </p>
            <p>
              Each piece is created with intention — a conversation between the
              artist, the medium, and the viewer.
            </p>

            <div className="stat-row">
              <div className="stat">
                <div className="stat-num">15+</div>
                <div className="stat-label">Years Active</div>
              </div>
              <div className="stat">
                <div className="stat-num">50+</div>
                <div className="stat-label">Works Sold</div>
              </div>
              <div className="stat">
                <div className="stat-num">200+</div>
                <div className="stat-label">Students</div>
              </div>
            </div>

            <button className="btn btn-primary">View Collection →</button>
          </div>
        </div>

        {/* ─── TIMELINE ─── */}
        <div style={{ marginTop: 100 }}>
          <div className="section-header">
            <div className="section-ornament">
              <div className="section-ornament-line" />
              <span className="section-label">Recognition</span>
              <div className="section-ornament-line" />
            </div>
            <h2 className="section-title">
              Exhibitions <em>&amp; Awards</em>
            </h2>
            <div className="section-rule" />
          </div>

          <div className="about-timeline">
            {timeline.map(([yr, ev]) => (
              <div key={yr + ev} className="about-timeline-item">
                <div className="about-timeline-year">{yr}</div>
                <div className="about-timeline-event">{ev}</div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}
